import { createContext, useContext, useState } from "react";

export const BRAND = "ABAITA";
export const WHATSAPP_NUMBER = "5215517060230";
export const INSTAGRAM_URL = "https://instagram.com/abaitayesodhaolam";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

const es = {
  nav: { rooms: "Espacios", availability: "Disponibilidad", amenities: "Amenidades", rules: "Reglas", contact: "Contacto", book: "Reservar" },
  hero: {
    overline: "Hospedaje kosher · Ciudad de México",
    line1: "Un espacio kosher",
    line2: "lejos de casa",
    line3: "en la Ciudad de México",
    sub: "Un departamento cálido y Shabat-friendly para estancias cortas con un precio muy accesible pensado para nuestra comunidad y cumplir con la mitzvá de Hajnasat Orjim. Tres recámaras, cocina kosher y una excelente ubicación. Estancia máxima de 1 semana.",
    cta: "Reservar por WhatsApp",
    secondary: "Ver los espacios",
    scroll: "Desliza",
  },
  marquee: ["Shabat Friendly", "Snacks Kosher", "Cocina Kosher", "Cerca de Sinagogas", "Family Friendly", "Estancias Cortas", "Precio Accesible"],
  about: {
    overline: "El proyecto",
    title: "Creado por Yesod Haolam, para la comunidad",
    body: "ABAITA nace para que cualquier miembro de la comunidad judía que visite la Ciudad de México o necesite quedarse en la zona de Interlomas, tenga un espacio kosher, digno, cálido y accesible donde hospedarse. Un departamento dividido en tres recámaras independientes que se pueden rentar por separado o en su totalidad.",
    chapters: [
      { n: "01", title: "Shabat Friendly", text: "Plata caliente, urna para agua, llaves manuales sin electrónicos, temporizadores de luz y velas de Shabat disponibles. Llega el viernes sin preocupaciones." },
      { n: "02", title: "Totalmente Kosher", text: "Cocina kosher equipada y una canasta de snacks kosher de bienvenida para que te sientas en casa desde el primer momento." },
      { n: "03", title: "Excelente Ubicación", text: "En una prominente zona judía: cerca del Hospital Ángeles de Interlomas y de Paseo Interlomas, a pasos de las sinagogas Shaare Tzion y Kolel Aram Zoba Interlomas (MonteCarlo), y de la tevilá para mujeres." },
    ],
  },
  rooms: {
    overline: "Los espacios",
    title: "Tres recámaras, un solo hogar",
    perNight: "por noche",
    guests: "huéspedes",
    bookRoom: "Reservar esta recámara",
    whole: "Departamento completo",
    wholeText: "Las tres recámaras, cocina, sala y comedor solo para ti y tu familia.",
    bookWhole: "Reservar todo el departamento",
    list: [
      { id: "room1", name: "Recámara Principal", desc: "Dos camas queen y baño completo. Amplia y luminosa, ideal para familias.", price: 600, capacity: 4 },
      { id: "room2", name: "Recámara Jardín", desc: "Dos camas individuales y baño completo.", price: 400, capacity: 2 },
      { id: "room3", name: "Recámara Estudio", desc: "Una cama queen y baño completo. Íntima, acogedora y accesible.", price: 500, capacity: 2 },
    ],
    wholePrice: 1500,
    wholeCapacity: 8,
  },
  availability: {
    overline: "Disponibilidad",
    title: "Consulta las fechas antes de escribirnos",
    legendAvailable: "Disponible",
    legendOccupied: "Ocupado",
    legendShabbat: "Shabat",
    legendHoliday: "Festividad judía",
    note: "La disponibilidad se actualiza constantemente. La reservación se confirma únicamente por WhatsApp.",
    hint: "Toca las fechas que te interesan en el calendario y se agregarán a tu mensaje de WhatsApp.",
    yourDates: "Tus fechas",
    clear: "Limpiar fechas",
    tabs: { room1: "Principal", room2: "Jardín", room3: "Estudio", whole: "Depto. completo" },
    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    days: ["L", "M", "M", "J", "V", "S", "D"],
  },
  amenities: {
    overline: "Amenidades",
    title: "Todo lo que necesitas, como en casa",
    list: [
      "Plata y urna (cafetera), velas y copa para Shabat, kit de Havdalá",
      "Lámparas de Shabat",
      "Chapas mecánicas, sin electrónicos",
      "Snacks kosher disponibles durante la estancia",
      "Cocina kosher equipada",
      "Wifi de alta velocidad",
      "Baño completo en cada recámara",
      "Libros de rezo",
      "Family friendly: cuna, silla de comer, juguetes y juegos de mesa",
      "Estacionamiento disponible",
      "Servicio de limpieza diaria con costo adicional",
      "Opción de lavado de ropa con previo aviso",
    ],
  },
  rules: {
    overline: "",
    title: "Reglas de ABAITA",
    notice: "Al reservar por WhatsApp confirmas que leíste y aceptas el reglamento de ABAITA.",
    list: [
      "Check-in 12:00 PM · Check-out 12:00 PM",
      "Para confirmar tu reservación es necesario aceptar el aviso de reglamento de ABAITA",
      "Estancia máxima de 1 semana",
      "Es necesario contar con una referencia de alguien conocido en México",
      "Para reservar se pide un depósito de $1,500 MXN, que se abona al total de la estancia",
      "Puedes cancelar sin costo hasta 48 horas antes de tu llegada; dentro de las 48 horas no hay devolución del depósito",
      "En caso de daños a las instalaciones por parte del huésped, ABAITA podrá no reembolsar el depósito",
      "No se permite el ingreso de comida no kosher",
      "No se permite el ingreso de mascotas",
      "Se prohíben eventos y reuniones de cualquier tipo",
      "Se prohíbe música alta y gritos, por respeto a los vecinos",
      "Para lavar ropa se indicarán los días en que puedes dejarla en un cesto; la encargada de limpieza la tendrá lista",
      "Se respetan en todo momento las reglas del condominio",
    ],
  },
  gallery: { overline: "Galería", title: "Un vistazo a los espacios" },
  contact: {
    overline: "Contacto",
    title: "Reserva tu estancia",
    body: "Toda reservación se realiza directamente por WhatsApp. Escríbenos con tus fechas y la recámara que te interesa, y confirmaremos a la brevedad.",
    whatsapp: "Escríbenos por WhatsApp",
    instagram: "Síguenos en Instagram",
    location: "Av. Club de Golf Lomas 3, Torres Placet, Lomas Country Club, Interlomas",
  },
  footer: { made: "Hecho con amor en la CDMX", admin: "Acceso administrador" },
  waMessages: {
    general: "Hola.... Me interesa hospedarme en ABAITA. ¿Me pueden ayudar con la disponibilidad? He leído y acepto el reglamento de ABAITA.",
    room1: "Hola.... Me interesa hospedarme en ABAITA. ¿Me pueden ayudar con la disponibilidad? He leído y acepto el reglamento de ABAITA.",
    room2: "Hola.... Me interesa hospedarme en ABAITA. ¿Me pueden ayudar con la disponibilidad? He leído y acepto el reglamento de ABAITA.",
    room3: "Hola.... Me interesa hospedarme en ABAITA. ¿Me pueden ayudar con la disponibilidad? He leído y acepto el reglamento de ABAITA.",
    whole: "Hola.... Me interesa hospedarme en ABAITA. ¿Me pueden ayudar con la disponibilidad? He leído y acepto el reglamento de ABAITA.",
  },
};

const en = {
  nav: { rooms: "Spaces", availability: "Availability", amenities: "Amenities", rules: "House Rules", contact: "Contact", book: "Book Now" },
  hero: {
    overline: "Kosher hospitality · Mexico City",
    line1: "A kosher space",
    line2: "away from home",
    line3: "in Mexico City",
    sub: "A warm, Shabbat-friendly apartment for short stays at a very affordable price, made for our community and to fulfill the mitzvah of Hachnasat Orchim. Three bedrooms, a kosher kitchen, and an excellent location. Maximum stay of 1 week.",
    cta: "Book via WhatsApp",
    secondary: "See the spaces",
    scroll: "Scroll",
  },
  marquee: ["Shabbat Friendly", "Kosher Snacks", "Kosher Kitchen", "Near Synagogues", "Kids Friendly", "Short Stays", "Budget Friendly"],
  about: {
    overline: "The project",
    title: "Created by Yesod Haolam, for the community",
    body: "ABAITA was created so every member of the Jewish community visiting Mexico City or needing to stay in the Interlomas area has a kosher, dignified, warm, and affordable place to stay. One apartment divided into three independent bedrooms, rentable separately or as a whole.",
    chapters: [
      { n: "01", title: "Shabbat Friendly", text: "Hot plate, water urn, manual non-electronic keys, light timers, and Shabbat candles ready for you. Arrive on Friday worry-free." },
      { n: "02", title: "Totally Kosher", text: "An equipped kosher kitchen plus a welcome basket of kosher snacks so you feel at home from minute one." },
      { n: "03", title: "Excellent Location", text: "In a prominent Jewish area: near Hospital Ángeles de Interlomas and Paseo Interlomas, steps from the Shaare Tzion and Kolel Aram Zoba Interlomas (MonteCarlo) synagogues, and the women's mikveh." },
    ],
  },
  rooms: {
    overline: "The spaces",
    title: "Three bedrooms, one home",
    perNight: "per night",
    guests: "guests",
    bookRoom: "Book this room",
    whole: "Entire Apartment",
    wholeText: "All three bedrooms, kitchen, living and dining room just for you and your family.",
    bookWhole: "Book the entire apartment",
    list: [
      { id: "room1", name: "Master Bedroom", desc: "Two queen beds and a full bathroom. Spacious and bright, ideal for families.", price: 600, capacity: 4 },
      { id: "room2", name: "Garden Bedroom", desc: "Two twin beds and a full bathroom.", price: 400, capacity: 2 },
      { id: "room3", name: "Studio Bedroom", desc: "One queen bed and a full bathroom. Intimate, cozy, and budget-friendly.", price: 500, capacity: 2 },
    ],
    wholePrice: 1500,
    wholeCapacity: 8,
  },
  availability: {
    overline: "Availability",
    title: "Check the dates before messaging us",
    legendAvailable: "Available",
    legendOccupied: "Occupied",
    legendShabbat: "Shabbat",
    legendHoliday: "Jewish holiday",
    note: "Availability is updated regularly. Bookings are confirmed exclusively via WhatsApp.",
    hint: "Tap the dates you're interested in on the calendar and they'll be added to your WhatsApp message.",
    yourDates: "Your dates",
    clear: "Clear dates",
    tabs: { room1: "Master", room2: "Garden", room3: "Studio", whole: "Entire Apt." },
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    days: ["M", "T", "W", "T", "F", "S", "S"],
  },
  amenities: {
    overline: "Amenities",
    title: "Everything you need, just like home",
    list: [
      "Shabbat hot plate & urn (coffee maker), Shabbat candles & cup, havdalah kit",
      "Shabbat lamps",
      "Mechanical locks, no electronics needed",
      "Kosher snacks available throughout your stay",
      "Equipped kosher kitchen",
      "High-speed Wi-Fi",
      "Full bathroom in every bedroom",
      "Prayer books (siddurim)",
      "Family friendly: crib, high chair, toys & board games",
      "Parking space available",
      "Daily cleaning service at an additional cost",
      "Laundry service available upon request",
    ],
  },
  rules: {
    overline: "",
    title: "ABAITA's Rules",
    notice: "By booking via WhatsApp you confirm that you have read and accept ABAITA's house rules.",
    list: [
      "Check-in 12:00 PM · Check-out 12:00 PM",
      "To confirm your booking, you must accept ABAITA's house rules notice",
      "Maximum stay of 1 week",
      "A reference from someone known in Mexico is required",
      "A $1,500 MXN deposit is required to book, credited toward your total stay",
      "Free cancellation up to 48 hours before arrival; within 48 hours the deposit is non-refundable",
      "In case of damage to the facilities caused by the guest, ABAITA may withhold the deposit",
      "Non-kosher food is not allowed inside",
      "No pets allowed",
      "Events and gatherings of any kind are prohibited",
      "Loud music and shouting are prohibited, out of respect for the neighbors",
      "Laundry days will be shared with you — leave your clothes in the basket and our housekeeper will have them ready",
      "Condominium rules must be respected at all times",
    ],
  },
  gallery: { overline: "Gallery", title: "A glimpse of the spaces" },
  contact: {
    overline: "Contact",
    title: "Book your stay",
    body: "All bookings are made directly through WhatsApp. Message us with your dates and the room you'd like, and we'll confirm as soon as possible.",
    whatsapp: "Message us on WhatsApp",
    instagram: "Follow us on Instagram",
    location: "Av. Club de Golf Lomas 3, Torres Placet, Lomas Country Club, Interlomas",
  },
  footer: { made: "Made with love in Mexico City", admin: "Admin access" },
  waMessages: {
    general: "Hello... I'm interested in staying at ABAITA. Could you help me with availability? I have read and accept ABAITA's house rules.",
    room1: "Hello... I'm interested in staying at ABAITA. Could you help me with availability? I have read and accept ABAITA's house rules.",
    room2: "Hello... I'm interested in staying at ABAITA. Could you help me with availability? I have read and accept ABAITA's house rules.",
    room3: "Hello... I'm interested in staying at ABAITA. Could you help me with availability? I have read and accept ABAITA's house rules.",
    whole: "Hello... I'm interested in staying at ABAITA. Could you help me with availability? I have read and accept ABAITA's house rules.",
  },
};

const dictionaries = { es, en };

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("es");
  const t = dictionaries[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
